import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import PropTypes from 'prop-types';
import { testAttributes } from './Constants';
import isInternalUrl from '../../../utilities/isInternalUrl';

const Link = ({
    href = '',
    children,
    activeClassName = '',
    activeStyle = {},
    partiallyActive = null,
    ...props
}) => 
{
    const isInternal = isInternalUrl(href);

    if (!href)
    {
        return (
            <a
                role="button"
                tabIndex={0}
                data-testid={testAttributes.ANCHOR}
                {...props}
                onClick={e => e.preventDefault()} 
                onKeyDown={e =>
                {
                    if (e.key === 'Enter' || e.key === ' ')
                    {
                        e.preventDefault();
                    }
                }}
            >
                {children}
            </a>
        );
    }

    if (!isInternal) 
    {
        return (
            <a href={href} data-testid={testAttributes.ANCHOR} {...props}>
                {children}
            </a>
        );
    }
    return (
        <GatsbyLink
            to={href}
            activeClassName={activeClassName}
            activeStyle={activeStyle}
            partiallyActive={partiallyActive}
            data-testid={testAttributes.LINK} 
            {...props}
        >
            {children}
        </GatsbyLink>
    );
};

Link.propTypes = {
    /** Text or React node wrapped within this component (e.g. <Link>children</Link>, <a>children</a>) */
    children: PropTypes.node.isRequired,
    /** URL that the hyperlink points to */
    href: PropTypes.string,
    /** For Gatsby's Link only. A class name that will be applied the current item is active */
    activeStyle: PropTypes.object,
    /** For Gatsby's Link only. A style object that will be applied when the current item is active */
    activeClassName: PropTypes.string,
    /** For Gatsby's Link only. Whether partial URLs are considered active (e.g. /blog#hello-world matches <Link to="/blog"> if partiallyActive is true) */
    partiallyActive: PropTypes.bool,
};

export default Link;
